import { AppUser } from '@/types'

export const getUserName = (user: AppUser) => {
  const name = `${user.first_name} ${user.last_name}`
  return name.trim() ? name : user.uid
}
